import Cookies from 'js-cookie';

const USER_KEY = 'user';
const TOKEN_KEY = 'token';
const ZS_TOKEN = 'zs-access-token';
// 设置token
export const setToken = (token) => {
  Cookies.set(TOKEN_KEY, token, { path: '/' });  //expires: 1 / 24,
  localStorage.setItem(TOKEN_KEY, token)
};
// 获取token
export const getToken = () => {
  let token = Cookies.get(TOKEN_KEY, { path: '/' });
  if (!token) {
    token = localStorage.getItem(TOKEN_KEY)
  }
  return token
};
// 设置用户信息

let defaultUser = {
  name: "用户_rfWpjk",
  phoneNumber: "",
  grade: "",
}
export const setUser = (user) => {
  if (!user) {
    user = defaultUser
  }
  let userStr = JSON.stringify({ ...defaultUser, ...user });
  Cookies.set(USER_KEY, userStr);
  localStorage.setItem(USER_KEY, userStr);
};
// 获取用户信息
export const getUser = () => {
  let user;
  if (Cookies.get(USER_KEY)) {
    user = JSON.parse(Cookies.get(USER_KEY));
    return user
  } else if ( localStorage.getItem(USER_KEY)) {
    user = JSON.parse(localStorage.getItem(USER_KEY))
  } else {
    user = defaultUser
  }
  return user

};
// 清除token
export const removeToken = () => {
  Cookies.remove(TOKEN_KEY, {
    path: '/'       // 关键修复：与 setToken 的 path 一致
  });
  localStorage.removeItem(TOKEN_KEY);
};
// 清除用户信息
export const removeUser = () => {
  Cookies.remove(USER_KEY);
  localStorage.removeItem(USER_KEY);
};

// 清除Cookies
export const removeZsToken = () => {
  Cookies.remove(ZS_TOKEN);
  localStorage.removeItem(ZS_TOKEN)
};

